// extracted by mini-css-extract-plugin
module.exports = {"form":"_14op2KWfxaw1Qbm4xs1Uor","form--changed":"_2Eb0lbmzwnn8jcL8wL3Klo","form--loading":"bK4wmeVUUiplrAqyR5Hof","spinner":"_3alMNQOp8UBVlmKFIPCJNV"};